import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Redirect, Link, withRouter} from 'react-router-dom';
import actions from './stream.actions';
import {DocumentTitle, Spinner, Avatar, PrimaryButton, FancyButton} from '../widgets';
import ActivityCard from './ActivityCard';
import SuggestionCard from './SuggestionCard';
import {CommunityCard, MinimalCommunityNotice} from '../community';
import {ProfileCard, suggestionsActions} from '../profile';
import {retrieveProfile} from '../profile/profile.actions';
import {uiActions} from '../chrome';
import seedrandom from 'seedrandom';
import {STREAM_WHITELISTED_USERS} from '../betaFeatureWhiteList';
import {getSteps} from '../profile/BioHelper';
import communityActions from '../community/community.actions';
import ActionsPopUp from '../mobile/bottom-nav-actions/ActionPopUp';
import sessionActions from '../user/session.actions';

import './ActivityStreamPage.css';

const COMMUNITY_NUM = 3;
const AVATAR_NUM = 15;
// const SUGGEST_ACTIVITY_PROB = 0.4; // chance of inserting a suggested activity
// const SUGGESTIONS_LIST = ['suggest_comm', 'suggest_prov', 'tutorial', 'top_comm', 'top_prov'];
const SUGGEST_ACTIVITY_PROB = 0.25;
const SUGGESTIONS_LIST = ['suggest_comm', 'suggest_prov'];

class ActivityStreamPage extends Component {
	constructor(props) {
		super(props);

		this.state = {
			uuid: null,
			tab: 'stream',
			proportion: 0,
			showActionsPopUp: false
		};

		this.changeTab = tab => this.setState({tab});

		this.scrollHandler = () => {
			// Find the proportion of the header height has been scrolled rounded to 10%.
			let proportion = window.scrollY / window.innerHeight / 0.45;
			proportion = Math.min(Math.max(Math.round(proportion * 10) / 10, 0), 1); // Limit and round to 0.1
			if (proportion !== this.state.proportion) {
				this.setState({proportion});
			}
		};

		this.optimisedScrollHandler = () => window.requestAnimationFrame(this.scrollHandler);

		this.unlisten = this.props.history.listen((history, action) => {
			if (
				this.props.isMobile &&
				(this.props.streamPromotionAddModelStatus === true ||
					this.props.communityListingModelStatus === true)
			) {
				this.props.closeModels();
				this.props.clearModels();
				this.props.history.goForward();
			}
		});
	}

	componentWillReceiveProps(newProps) {
		// if the user has just logged in -> load stream
		if (!this.props.sessionProvider && newProps.sessionProvider) {
			this.setState(
				{
					uuid: newProps.match.params.uuid || newProps.sessionProvider.user.uuid,
					uuidHash: this.hashUuid(newProps.match.params.uuid || newProps.sessionProvider.user.uuid)
				},
				() => {
					this.props.loadStream(newProps.match.params.uuid || newProps.sessionProvider.user.uuid);
					this.props.retrieveProfile(this.props.sessionProvider.provider.profile.uniqueName);
				}
			);
		}
		// load community avatars for profile side pane
		if (!this.props.communities && newProps.communities && newProps.communities.length > 0) {
			newProps.communities.forEach(community => this.props.loadCommunityAvatars(community.uuid));
		}
	}

	componentDidMount() {
		this.props.startSuggestions();
		window.addEventListener('scroll', this.optimisedScrollHandler);

		if (this.props.sessionProvider) {
			const uuid = this.props.match.params.uuid || this.props.sessionProvider.user.uuid;
			this.setState({uuid, uuidHash: this.hashUuid(uuid)});
			this.props.loadStream(uuid);
			this.props.retrieveProfile(this.props.sessionProvider.provider.profile.uniqueName);
		}
	}

	componentWillUnmount() {
		this.props.clearStream(); // TODO: remove this when deploying for all users
		this.props.stopSuggestions();
		this.props.closeModels();
		//this.unlisten();
		window.removeEventListener('scroll', this.optimisedScrollHandler);
	}

	/* Turns uuid string into single number */
	hashUuid(uuid) {
		let hash = 0;
		for (let c of uuid) {
			hash += c.charCodeAt(0);
		}
		return hash;
	}

	/* Return suggestion component for idx */
	getSuggestionComponent(idx) {
		switch (SUGGESTIONS_LIST[idx]) {
			case 'suggest_comm':
				return <SuggestionCard />;
			case 'suggest_prov':
				return <SuggestionCard providers={true} />;
			case 'top_comm':
			case 'top_prov':
				return <ActivityCard title={`${SUGGESTIONS_LIST[idx]}`} content="Suggested activity" />;
			case 'tutorial':
				return <ActivityCard title={`${SUGGESTIONS_LIST[idx]}`} content="Suggested activity" />;
			default:
				return undefined; // should never get here
		}
	}

	closeActionPopUp = () => {
		this.setState({
			showActionsPopUp: false
		});
	};

	render() {
		const {
			sessionProvider,
			activities,
			offset,
			isLoading,
			endOfStream,
			onAddComment,
			isMobile,
			favourites,
			showInvite,
			communities,
			communityAvatars,
			suggestedCommunities,
			showCommunityPicker,
			showAffiliatedCommunities
		} = this.props;

		// // only allow admins to view this page
		if (
			sessionProvider &&
			sessionProvider.user &&
			!sessionProvider.user.admin &&
			!STREAM_WHITELISTED_USERS.includes(sessionProvider.user.uuid)
		) {
			return <Redirect to="/" />;
		}

		// display spinner while loading initial page
		if ((isLoading && offset === 0) || !sessionProvider) {
			return (
				<DocumentTitle title="Your Stream - B2Me">
					<main>
						<Spinner />
					</main>
				</DocumentTitle>
			);
		}

		const avatarImage =
			sessionProvider && sessionProvider.provider && sessionProvider.provider.profile.avatarImage;
		const {firstname, lastname} = sessionProvider.user;
		const profileCompletion = Math.round(sessionProvider.provider.profileCompletion * 100);
		const profileSteps = Object.values(getSteps(this.props));
		const nextStep = profileSteps.filter(step => !step.completed(this.props))[0];

		const currentUserUuid = sessionProvider && sessionProvider.user && sessionProvider.user.uuid;

		let suggestionIdx = 0; // allows rotation of suggested activity types
		const randNumGen = seedrandom(this.state.uuidHash); // use uuidHash to have dynamic insertions per user

		return (
			<DocumentTitle title="Your Stream - B2Me">
				<main className="ActivityStream">
					{/* Profile Section */}
					{(!isMobile || this.state.tab === 'profile') && (
						<section className="Profile">
							<div
								className={`profileCont ${
									this.state.proportion >= 1 && !isMobile ? 'scrolled' : ''
								}`}>
								<div className="profileTop">
									<Avatar
										backgroundImage={avatarImage}
										size={this.state.proportion >= 1 && !isMobile ? 96 : 192}
									/>
									<h1>{firstname || lastname ? `${firstname} ${lastname}` : <em>New user</em>}</h1>
								</div>
								<hr />

								<div className="profileBox">
									<div className="boxHeader">
										<span>Profile Completion</span>
										<i className="icon icon-account_circle" />
									</div>
									<div className="boxContent">
										<div className="progressBar">
											<div className="bar">
												<span className="progress" style={{width: `${profileCompletion}%`}} />
											</div>
											<span>{profileCompletion}%</span>
										</div>

										{profileCompletion !== 100 && (
											<div className="nextSteps">
												<Link to={`/@${sessionProvider.provider.profile.uniqueName}`}>
													Complete your profile now
												</Link>
												<br />
												<span className="step">Next step:</span>
												<span>{nextStep.label}</span>
												{nextStep.instructions}
											</div>
										)}
									</div>
								</div>
								<hr />

								<div className="profileBox">
									<div className="boxHeader">
										<span>My Providers</span>
										<i className="icon icon-favorite" />
									</div>
									{favourites && favourites.length > 0 ? (
										<div className="boxContent">
											<ul className="providersList">
												{favourites.slice(0, AVATAR_NUM).map(fav => (
													<li key={fav.uuid}>
														<Link to={`/@${fav.profile.uniqueName}`}>
															<Avatar backgroundImage={fav.profile.avatarImage} size={32} />
														</Link>
													</li>
												))}
											</ul>
											<Link to={`/collections/${sessionProvider.provider.profile.uniqueName}`}>
												View more
											</Link>
										</div>
									) : (
										<div className="boxContent">
											<span>You haven't added anyone to your collection yet</span>
										</div>
									)}
								</div>
								<hr />

								<div className="profileBox">
									<div className="boxHeader">
										<span>Expand your network</span>
										<i className="icon icon-group_add" />
									</div>
									<div className="boxContent">
										<PrimaryButton onClick={showInvite} icon="insert_invitation">
											Invite someone to B2Me
										</PrimaryButton>

										<FancyButton onClick={showCommunityPicker}>
											<span className="icon icon-people" />
											<span>Join a community</span>
										</FancyButton>
									</div>
								</div>
								<hr />

								{communities && communities.length
									? communities.slice(0, COMMUNITY_NUM).map(community => (
											<React.Fragment key={community.uuid}>
												<div className="profileBox">
													<div className="boxHeader">
														<span>{community.name}</span>
														<i className="icon icon-people" />
													</div>
													<div className="boxContent">
														<ul className="providersList">
															{communityAvatars &&
																communityAvatars[community.uuid] &&
																communityAvatars[community.uuid]
																	.slice(0, AVATAR_NUM)
																	.map(member => (
																		<li key={member.uniqueName}>
																			<Link to={`/@${member.uniqueName}`}>
																				<Avatar backgroundImage={member.avatarImage} size={32} />
																			</Link>
																		</li>
																	))}
														</ul>
														{/* TODO: change this language? */}
														<span>New members</span>

														<div className="communityLinks">
															<div>
																<Link to={`/members/${community.profile.uniqueName}`}>Members</Link>
															</div>
															<div>
																<Link to={`/!${community.profile.uniqueName}`}>Notices</Link>
															</div>
															<div>
																<Link to={`/about/${community.profile.uniqueName}`}>Profile</Link>
															</div>
														</div>
													</div>
												</div>
												<hr />
											</React.Fragment>
									  ))
									: null}
							</div>
						</section>
					)}

					{/* Stream Section */}
					{(!isMobile || this.state.tab === 'stream') && (
						<section className="Stream">
							{activities && activities.length > 0 ? (
								<React.Fragment>
									{/* MAP ACTIVITIY CARDS */}
									{activities.map((activity, idx) => {
										// Randomly insert suggestion card and rotate index
										let suggestionCard = undefined;
										if (randNumGen() < SUGGEST_ACTIVITY_PROB) {
											suggestionCard = this.getSuggestionComponent(suggestionIdx);
											suggestionIdx = (suggestionIdx + 1) % SUGGESTIONS_LIST.length;
										}

										return (
											<React.Fragment
												key={`${activity.uuid}_${suggestionCard ? suggestionIdx : undefined}`}>
												{activity.cardType === 'NOTICE' ? (
													<MinimalCommunityNotice
														{...activity.notice}
														community={activity.community}
														sessionProvider={sessionProvider}
														onAddComment={onAddComment}
													/>
												) : (
													<ActivityCard {...activity} />
												)}

												{suggestionCard}
											</React.Fragment>
										);
									})}

									{!endOfStream ? (
										<React.Fragment>
											{!isLoading ? (
												<button
													className="loadMoreBtn"
													onClick={() => this.props.loadStream(this.state.uuid)}>
													Load More
												</button>
											) : (
												<Spinner />
											)}
										</React.Fragment>
									) : (
										<p>You're all caught up!</p>
									)}
								</React.Fragment>
							) : (
								<div className="noActivities">
									<div className="info">
										<p>You don't have any activities yet!</p>
										<p>
											The B2Me stream is a great way to receive updates on your B2Me providers and
											communities. Favourite some providers and join some local communities to get
											started.
										</p>
										<br />
										<p>
											You can explore the marketplace <Link to="/search-category/">here</Link> or
											check out the suggestions below!
										</p>
									</div>

									{suggestedCommunities &&
										suggestedCommunities.map(community => {
											return (
												<ul key={community.uuid}>
													<CommunityCard community={community} />
													{community.suggestedMembers &&
														community.suggestedMembers.map(provider => (
															<ProfileCard key={provider.uuid} provider={provider} />
														))}
												</ul>
											);
										})}
								</div>
							)}
						</section>
					)}

					{/* Right Pane Section */}
					{(!isMobile || this.state.tab === 'rightPane') && <section className="rightPane" />}

					{isMobile && this.state.showActionsPopUp && (
						<ActionsPopUp
							actions={[
								{
									key: 'create_promotion',
									label: 'Create Promotion',
									icon: 'icon-redeem',
									onSelect: e => {
										showAffiliatedCommunities(currentUserUuid);
										this.setState({showActionsPopUp: false});
									}
								}
							]}
							onClose={this.closeActionPopUp}
						/>
					)}

					{/* {(!isMobile || this.state.tab === 'promotions') && (
						<section className="promotions">
							<div>Promotions</div>
						</section>
					)} */}

					{/* Mobile Tabs */}
					{isMobile && (
						<nav className="mobileTabs">
							<div
								className={`tab ${this.state.tab === 'profile' ? 'current' : ''}`}
								onClick={() => this.changeTab('profile')}>
								<i className="icon icon-account_circle" />
								<span>You</span>
							</div>
							<div
								className="tab promotions"
								onClick={() => {
									this.setState({showActionsPopUp: true});
								}}>
								<i className="icon icon-add_box" />
								<span>Add</span>
							</div>
							<div
								className={`tab ${this.state.tab === 'stream' ? 'current' : ''}`}
								onClick={() => this.changeTab('stream')}>
								{/* <i className="icon icon-home" /> */}
								<i className="icon icon-view_day" />
								<span>Stream</span>
							</div>
							{/* <div
								className={`tab ${this.state.tab === 'rightPane' ? 'current' : ''}`}
								onClick={() => this.changeTab('rightPane')}>
								<i className="icon icon-announcement" />
								<span>News</span>
							</div> */}
						</nav>
					)}
				</main>
			</DocumentTitle>
		);
	}
}

export default withRouter(
	connect(
		({stream, session, ui, profile, suggestions}) => ({
			favourites: profile && profile.favourites,
			communities: profile && profile.communities,
			sessionProvider: session && session.current,
			isLoading: stream.loading,
			offset: stream.offset,
			activities: stream.activities,
			endOfStream: stream.endOfStream,
			communityAvatars: stream.communityAvatars,
			isMobile: ui.screenSize === 'mobile' || ui.screenSize === 'tablet',
			suggestedCommunities: suggestions && suggestions.communities,
			profile: profile,
			communityListingModelStatus: stream.communityListingModelStatus,
			streamPromotionAddModelStatus: stream.streamPromotionAddModelStatus
		}),
		dispatch => ({
			retrieveProfile: uniqueName => dispatch(retrieveProfile(uniqueName)),
			loadStream: uuid => dispatch(actions.loadStream(uuid)),
			clearStream: () => dispatch(actions.clearStream()),
			startSuggestions: () => dispatch(suggestionsActions.commenceSuggestions()),
			stopSuggestions: () => dispatch(suggestionsActions.suggestionsStopped()),
			showInvite: () => dispatch(uiActions.uiModal('invite')),
			loadCommunityAvatars: uuid => dispatch(actions.loadCommunityAvatars(uuid)),
			showCommunityPicker: () => {
				dispatch(
					uiActions.uiPickerCallback(community => {
						dispatch(communityActions.joinCommunity(community.uuid));
						dispatch(uiActions.uiModal(null));
						dispatch(
							uiActions.uiMessage(
								community.type === 'open'
									? `You have joined ${
											community.name
									  }! View the community page for the member list, notices and more`
									: `Your request to join ${community.name} has been sent`
							)
						);
						setTimeout(() => dispatch(actions.retrieveAffiliations()), 100); // BAD Dodgey hack to wait for community request to be sent -- probably a race condition
					})
				);
				dispatch(uiActions.uiModal('community-picker'));
			},
			openActions: () => {
				dispatch(uiActions.uiModal('popup-actions'));
			},
			showAffiliatedCommunities: currentUserUuid => {
				dispatch(sessionActions.retrieveSessionAffiliations(currentUserUuid));
				dispatch(uiActions.uiModal('mobile-community-list'));
				dispatch(actions.communityListingModelOpened());
			},
			closeModels: () => {
				dispatch(actions.communityListingModelClosed());
				dispatch(actions.streamPromotionAddModelClosed());
			},
			clearModels: () => {
				dispatch(uiActions.uiModal(null));
			}
		})
	)(ActivityStreamPage)
);



// WEBPACK FOOTER //
// ./src/stream/ActivityStreamPage.js